<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :default-params="defaultParams">
      <template #deviceNums="row">
        <div>{{ `${row.data.availableDevCount}/${row.data.deviceNums}` }}</div>
      </template>
      <template #status="row">
        <el-switch
          @change="handleEditStatus(row.data)"
          v-model="row.data.status"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </template>
      <template #operation="row">
        <template v-if="!typeOfView">
          <el-button type="primary " @click="handleDetail(row.data)" class="mb-5px" size="mini"
            >查看</el-button
          >
          <el-button type="primary " @click="handleEdit(row.data)" class="mb-5px" size="mini"
            >编辑</el-button
          >
          <el-button type="danger" @click="handleDel(row.data)" class="mb-5px" size="mini"
            >删除</el-button
          >
        </template>
      </template>
    </com-table>
  </div>
</template>

<script>
import { communityListApi, deleteCommunityApi, setCommunityStatus } from '@/api/community'
import { partnerCommunityListApi } from '@/api/partners'

export default {
  props: {
    model: {
      type: String,
      default: ''
    },
    defaultParams: {
      type: Object,
      default: () => {}
    },
    typeOfView: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      api: communityListApi,
      columns: [
        {
          label: '小区ID',
          prop: 'number'
        },
        {
          label: '小区名称',
          prop: 'name',
          width: 120
        },
        {
          label: '所在区域',
          prop: 'areaNames',
          width: 120
        },
        {
          label: '场地类型',
          prop: 'storeTypeName',
          width: 100
        },
        {
          label: '网点数',
          prop: 'storeCount',
          width: 80
        },
        {
          label: '设备数',
          prop: 'deviceNums',
          type: 'slot',
          slotName: 'deviceNums',
        },
        {
          label: '充电口数',
          prop: 'portNums',
          width: 100
        },
        {
          label: '订单数',
          prop: 'orderCount'
        },
        {
          label: '营业额',
          prop: 'turnover'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status',
          hidden: false
        },
        {
          label: '归属',
          prop: 'refBelongAgentName'
        },
        {
          label: '商家',
          prop: 'refBelongBusinessName',
          width: 120
        },
        {
          label: '电量',
          prop: 'powerConsumption',
        },
        {
          label: '用户数',
          prop: 'xdUserCount',
          width: 80
        },
        {
          label: '创建时间',
          prop: 'createTime',
          width: 120
        },
        // {
        //   label: '充值套餐',
        //   prop: 'rechargePlanBatchName',
        //   width: 120
        // },
        // {
        //   label: '收费标准',
        //   prop: 'chargePlanName',
        //   width: 130
        // },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          minWidth: '160'
        }
      ]
    }
  },

  watch: {
    typeOfView: {
      handler(val) {
        if (val) {
          this.columns.splice(-1, 1) // 隐藏操作列
          this.columns.find(item => item.prop === 'status').hidden = true // 隐藏状态开关
          if (val === 'partner') {
            this.api = partnerCommunityListApi
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    init() {
      this.$refs.tableRef.init()
    },
    handleDetail(row) {
      this.$router.push({ name: 'community-detail', query: { code: row.code } })
    },
    handleEdit(row) {
      this.$router.push({ name: 'community-edit', query: { type: 'edit', code: row.code } })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该小区及下属网点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          deleteCommunityApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    search(val) {
      this.$refs.tableRef.search(val)
    },
    handleEditStatus(row) {
      const params = {
        code: row.code,
        status: row.status
      }
      setCommunityStatus(params).then((res) => {
        this.$refs.tableRef.getList()
      }).catch((err) => {
        row.status = !row.status
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
